<ng-container *ngFor="let transaction of transactions">
  <tr class="transaction">
    <td class="cell icon">
      <i2g-icon name="card-paypal" size="custom" class="method-icon"></i2g-icon>
    </td>

    <td
      class="cell client"
      *ngIf="transaction.document?.client_name; else paymentCell"
    >
      {{ transaction.document?.client_name }}
    </td>

    <ng-template #paymentCell>
      <td class="cell client">
        {{ 'PAYMENTS.PAYPAL.TRANSACTION_HISTORY.PAYMENT' | translate }}
      </td>
    </ng-template>

    <td class="cell amount">
      {{ transaction?.amount | money: transaction?.currency }}
    </td>

    <td class="cell action" *ngIf="transaction.document">
      <div class="icon">
        <i2g-dropdown
          [dropdownGroupedItems]="
            menuActions[transaction.document?.document_type]
          "
          horizontalAlignment="right"
          [dynamicVAlignment]="true"
          [parentContainer]="parentContainer"
        >
          <ng-template
            let-closeCallback="closeCallback"
            let-transactionAction="dropdownItem"
          >
            <div tabindex="0" (click)="closeCallback()">
              <button
                class="option"
                (click)="handleMenuAction(transactionAction.id, transaction)"
              >
                {{ transactionAction.label | translate }}
              </button>
            </div>
          </ng-template>
        </i2g-dropdown>
      </div>
    </td>
  </tr>
</ng-container>
